
// region JS Imports

// region External Modules
import { EventEmitter } from "events"

import $ from "jquery"
// endregion External Modules

// Private Modules
import {
  isLocalStorageEnabled,

  getDataFromLocalStorage,

  setDataToLocalStorage,
} from "app/local_storages/native_api_adapter"
// Private Modules

// region Public Components
import Modal from "app/modal/show-modal"

import {
  init as CountryFollowButton_init,
} from "apps/spacious_website/components/countries/follow_button"
// endregion Public Components

// region Private Components
// endregion Private Components

// endregion JS Imports


const COOKIE_KEY_PREFIX_FOR_SEEN = "apps_spacious_website_components_countries_follow_prompt_modal__seen"


interface Selector {
  main: string
}
interface InputSelector {
  main?: string
}
const default_selector = {
  main: ".cell--countries--follow_prompt_modal",
}


class CountryUpdateSubscriptionModal extends EventEmitter {
  private selector: Selector

  private readonly $el: JQuery
  private readonly $modal = null as JQuery | null

  constructor(selector?: InputSelector){
    super()

    this.selector = Object.assign({}, default_selector, selector)

    this.$el = $(this.selector.main)

    if (this.$el.length === 0){ return }

    const unix_time_now = new Date().getTime()
    const country_slug = this.$el.data("country-slug")
    const cookie_key_for_seen = `${COOKIE_KEY_PREFIX_FOR_SEEN}/${country_slug}`

    if (country_slug.length === 0) { return }

    if (!isLocalStorageEnabled()) { return }

    // String
    const value_from_local_store = getDataFromLocalStorage(cookie_key_for_seen).data
    let unix_time_for_last_seen: null | number = null
    if (typeof value_from_local_store === "string") {
      const parsed_integer = parseInt(value_from_local_store, 10)
      if (!isNaN(parsed_integer)) {
        unix_time_for_last_seen = parsed_integer
      }
    }
    // (24 * 60 * 60 * 1000) = 1 day in ms
    const last_seen_within_time_period =
      unix_time_for_last_seen == null ?
        false :
        unix_time_for_last_seen + (24 * 60 * 60 * 1000) > unix_time_for_last_seen
    if (last_seen_within_time_period) { return }

    this.$modal = Modal.showModalWithContent(this.$el, {
      customContent: true,
    })

    CountryFollowButton_init({
      container: this.$modal[0] as HTMLElement,
    })
    .then((follow_buttons) => {
      follow_buttons.forEach((follow_button) => {
        follow_button.onFollowed(() => {
          this.close()
        })
      })
    })
    .done()

    setDataToLocalStorage(cookie_key_for_seen, unix_time_now.toString())
  }

  public close() {
    if (this.$modal == null) { return }

    this.$modal.modal("hide")
  }
}

const Factory = {
  create(selector?: InputSelector){
    return new CountryUpdateSubscriptionModal(selector)
  },
}

export {
  Factory,
}
